import React, { useState } from "react";
import './CheckBox.scss';

const CheckBox = (props) => {
    let [checked, setChecked] = useState(props.checked)
    let { labelTitle, id, onCheckedChange } = props

    const onChecked = (e, check) => {
        onCheckedChange(e.target.checked)
    }

    return (
        <div className="checkboxMain">
            <input type="checkbox" id={id} className='checkbox' onChange={(e) => onChecked(e)}/>
            <label className='nutritionProducts pointerC' id="checkLabel" htmlFor={id}>{labelTitle}</label>
        </div>
    )
}

CheckBox.defaultProps = {
    id: 1,
    checked: false,
    labelTitle: 'Title',
}

export default CheckBox;